(() => {
  'use strict';

  const lang = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
  const root = window.Shopify?.routes?.root || '/';
  const copy = {
    en:{pay:'Pay securely', preparing:'Preparing checkout…', error:'We could not prepare checkout. Please try again.'},
    nl:{pay:'Veilig betalen', preparing:'Checkout voorbereiden…', error:'We konden de checkout niet voorbereiden. Probeer het opnieuw.'},
    de:{pay:'Sicher bezahlen', preparing:'Checkout wird vorbereitet…', error:'Checkout konnte nicht vorbereitet werden. Bitte erneut versuchen.'},
    fr:{pay:'Paiement sécurisé', preparing:'Préparation du paiement…', error:'Impossible de préparer le paiement. Veuillez réessayer.'},
    fa:{pay:'پرداخت امن', preparing:'در حال آماده‌سازی پرداخت…', error:'پرداخت آماده نشد. لطفاً دوباره تلاش کنید.'},
    ar:{pay:'دفع آمن', preparing:'جارٍ تجهيز الدفع…', error:'تعذر تجهيز الدفع. يرجى المحاولة مرة أخرى.'}
  }[lang] || {pay:'Pay securely', preparing:'Preparing checkout…', error:'We could not prepare checkout. Please try again.'};

  const rowVariantIds = [
    '48512420348162','48512420544770','48512420380930','48512420413698','48512420446466',
    '48512420479234','48512420577538','48512407372034','48512407404802','48512407437570'
  ];

  const packageVariantIds = {
    silver:'48512407372034', gold:'48512407404802', diamond:'48512407437570'
  };

  // Storefront metadata is informational only. Entitlements and expiry are resolved server-side
  // from the paid Shopify variant/SKU; the browser is never the source of truth.
  const checkoutMeta = {
    '48512420348162': {modules:'supplements'},
    '48512420544770': {modules:'training', pt:'1'},
    '48512420380930': {modules:'training'},
    '48512420413698': {modules:'nutrition'},
    '48512420446466': {modules:'training,nutrition'},
    '48512420479234': {modules:'training,nutrition,supplements'},
    '48512420577538': {modules:'training,nutrition,supplements', pt:'1'},
    '48512407372034': {modules:'training', pt:'10', storeDiscount:'5'},
    '48512407404802': {modules:'training', pt:'15', nutritionDiscount:'50', storeDiscount:'10'},
    '48512407437570': {modules:'training,nutrition,supplements', pt:'15', followUp:'yes', storeDiscount:'15'}
  };

  const prepareCheckout = async (anchor, variantId) => {
    if (anchor.dataset.mbfBusy === '1') return;
    const meta = checkoutMeta[variantId];
    if (!meta) return;

    anchor.dataset.mbfBusy = '1';
    anchor.setAttribute('aria-busy','true');
    const original = anchor.textContent;
    anchor.textContent = copy.preparing;

    const properties = {
      '_MBF Modules': meta.modules,
      '_MBF Access Mode': 'server-managed',
      '_MBF Access Days': '0',
      '_MBF Access Version': '2'
    };
    if (meta.pt) properties['_MBF PT Sessions'] = meta.pt;
    if (meta.storeDiscount) properties['_MBF Store Discount'] = `${meta.storeDiscount}%`;
    if (meta.nutritionDiscount) properties['_MBF Nutrition Discount'] = `${meta.nutritionDiscount}%`;
    if (meta.followUp) properties['_MBF Follow-up'] = meta.followUp;

    try {
      const response = await fetch(`${root}cart/add.js`, {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[{id:Number(variantId),quantity:1,properties}]})
      });
      if (!response.ok) throw new Error(`cart/add ${response.status}`);
      window.location.assign(`${root}checkout`);
    } catch (error) {
      console.error('[MBF coaching checkout]', error);
      anchor.dataset.mbfBusy = '0';
      anchor.removeAttribute('aria-busy');
      anchor.textContent = original;
      window.alert(copy.error);
    }
  };

  const bindCheckout = (anchor, variantId) => {
    anchor.href = `${root}cart`;
    anchor.dataset.mbfServiceCheckout = variantId;
    anchor.addEventListener('click', (event) => {
      event.preventDefault();
      prepareCheckout(anchor, variantId);
    });
  };

  const addPayLink = (host, variantId, extraClass = '') => {
    if (!host || !variantId || host.querySelector('.mbf-service-pay')) return;
    const a = document.createElement('a');
    a.className = `mbf-service-pay ${extraClass}`.trim();
    a.textContent = `${copy.pay} →`;
    a.setAttribute('role','button');
    bindCheckout(a, variantId);
    host.appendChild(a);
  };

  const unlockedVault = document.querySelector('.pt-vault:not(.pt-vault--locked)');
  if (unlockedVault) {
    unlockedVault.querySelectorAll('.pt-price-row').forEach((row, index) => addPayLink(row, rowVariantIds[index], 'mbf-service-pay--row'));
    Object.entries(packageVariantIds).forEach(([tier, id]) => addPayLink(document.querySelector(`.ptl-package--${tier} .ptl-package__actions`), id, 'mbf-service-pay--package'));
  }

  const detailHost = document.querySelector('.pt-detail-hero[data-mbf-service-variant-id]');
  const detailId = detailHost?.dataset.mbfServiceVariantId || '';
  const detailPriceUnlocked = !!document.querySelector('.pt-detail-price-gate strong');
  if (detailId && detailPriceUnlocked) {
    const actions = document.querySelector('.pt-detail-hero .hero-actions');
    if (actions && !actions.querySelector('.mbf-service-pay')) {
      const a = document.createElement('a');
      a.className = 'button button--accent mbf-service-pay mbf-service-pay--detail';
      a.textContent = `${copy.pay} →`;
      a.setAttribute('role','button');
      bindCheckout(a, detailId);
      actions.prepend(a);
    }
  }

  const style = document.createElement('style');
  style.textContent = `
    .pt-vault:not(.pt-vault--locked) .pt-price-row{grid-template-columns:minmax(220px,1.18fr) minmax(120px,.38fr) minmax(160px,.5fr) auto}
    .mbf-service-pay{display:inline-flex;align-items:center;justify-content:center;min-height:42px;padding:10px 15px;border:1px solid rgba(255,255,255,.22);background:#fff;color:#111!important;text-decoration:none!important;font-size:10px;font-weight:900;letter-spacing:.075em;text-transform:uppercase;white-space:nowrap;transition:transform .2s ease,background .2s ease,border-color .2s ease,opacity .2s ease;cursor:pointer}
    .mbf-service-pay:hover{transform:translateY(-2px);background:#ff4b2b;color:#fff!important;border-color:#ff4b2b}.mbf-service-pay--package{background:#ff4b2b;color:#fff!important;border-color:#ff4b2b}.mbf-service-pay--detail{background:#fff!important;color:#111!important}.mbf-service-pay[aria-busy='true']{opacity:.65;pointer-events:none}
    @media(max-width:900px){.pt-vault:not(.pt-vault--locked) .pt-price-row{grid-template-columns:minmax(0,1fr) auto}.pt-vault:not(.pt-vault--locked) .pt-price-row__value{grid-column:1/-1}.pt-vault:not(.pt-vault--locked) .mbf-service-pay--row{grid-column:1/-1;width:100%;margin-top:2px}}
  `;
  document.head.appendChild(style);
})();
